import { Component, Input, ViewEncapsulation } from '@angular/core';
import { fiWidgetGetHeaderIcon } from '../widget-registry';

@Component({
    selector: 'fi-widget-icon',
    template: '<span [class]="getIconClass()"></span>',
    styleUrls: ['./icon.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FiWidgetIconComponent {
    @Input() widgetType;

    constructor() {}

    getIconClass() {
        return 'widget-icon ' + fiWidgetGetHeaderIcon(this.widgetType);
    }
}
